'use strict';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const $ = jQuery.noConflict();
$(function() {

	const expandingCta = {

		init: function() {
			this.cacheDOM();
			if (!this.section) {
				return;
			}
			this.isAlt = this.section.classList.contains('expanding-cta--alt');
			if (this.prefersReducedMotion()) {
				this.showContent();
				return;
			}
			gsap.registerPlugin(ScrollTrigger);
			ScrollTrigger.config({ignoreMobileResize: true});
			this.createTimeline();
			this.bindResize();
		},

		cacheDOM: function() {
			this.section = document.querySelector('.js-expanding-cta');
			if (!this.section) {
				return;
			}
			this.shape = this.section.querySelector('.js-expanding-cta-shape');
			this.texture = this.section.querySelector('.js-expanding-cta-texture');
			this.subtitle = this.section.querySelector('.js-expanding-cta-subtitle');
			this.actions = this.section.querySelector('.js-expanding-cta-actions');
		},

		prefersReducedMotion: function() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

		showContent: function() {
			const targets = [this.subtitle, this.actions].filter(Boolean);
			if (targets.length) {
				gsap.set(targets, {opacity: 1, y: 0});
			}
		},

		bindResize: function() {
			let timer;
			window.addEventListener('resize', () => {
				clearTimeout(timer);
				timer = setTimeout(this.reinit.bind(this), 250);
			});
		},

		reinit: function() {
			if (this.tl) {
				if (this.tl.scrollTrigger) {
					this.tl.scrollTrigger.kill();
				}
				this.tl.kill();
			}

			const shapeTargets = [this.shape, this.texture].filter(Boolean);
			const fadeTargets = [this.subtitle, this.actions].filter(Boolean);

			gsap.set(shapeTargets, {clearProps: 'borderRadius'});
			gsap.set(this.shape, {clearProps: 'width,height'});
			if (fadeTargets.length) {
				gsap.set(fadeTargets, {clearProps: 'opacity,transform'});
			}

			this.createTimeline();
		},

		createTimeline: function() {
			const fullWidth = this.shape.offsetWidth;
			const fullHeight = this.shape.offsetHeight;
			const shapeTargets = [this.shape, this.texture].filter(Boolean);
			const fadeTargets = [this.subtitle, this.actions].filter(Boolean);

			// Start: circle — fix height so content can't stretch it
			let altSize = 424;
			if (window.innerWidth < 769) {
				altSize = 200;
			} else if (window.innerWidth < 992) {
				altSize = 284;
			} else if (window.innerWidth <= 1300) {
				altSize = 374;
			}
			const circleSize = this.isAlt ? altSize : fullHeight;
			gsap.set(shapeTargets, {borderRadius: circleSize / 2});
			gsap.set(this.shape, {width: circleSize, height: circleSize});

			if (fadeTargets.length) {
				gsap.set(fadeTargets, {opacity: 0, y: 16});
			}

			this.tl = gsap.timeline({
				defaults: {ease: 'power2.inOut'},
				scrollTrigger: {
					trigger: this.section,
					start: 'center bottom',
					end: 'center center+=100',
					scrub: 0.8,
				},
			});

			// Expand circle → pill (borderRadius stays the same, only width changes)
			this.tl.to(this.shape, {
				width: fullWidth,
				duration: 0.6,
			}, 0);

			// Fade in content after shape is mostly expanded
			if (this.subtitle) {
				this.tl.to(this.subtitle, {opacity: 1, y: 0, duration: 0.25}, 0.55);
			}

			if (this.actions) {
				this.tl.to(this.actions, {opacity: 1, y: 0, duration: 0.25}, 0.72);
			}
		},
	};

	expandingCta.init();
});
